"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const History = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 18,
  height: 16,
  viewBox: "0 0 18 16",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.087 6.204l.36-.359a.833.833 0 011.178 1.179L3.857 8.79a.833.833 0 01-1.178 0L.91 7.023a.833.833 0 111.178-1.178l.285.285A7.514 7.514 0 019.654.5c4.148 0 7.513 3.356 7.513 7.5 0 4.143-3.365 7.5-7.514 7.5a7.502 7.502 0 01-5.516-2.407.833.833 0 111.222-1.133 5.836 5.836 0 004.294 1.873c3.232 0 5.848-2.613 5.848-5.833s-2.616-5.833-5.848-5.833a5.849 5.849 0 00-5.566 4.037zm5.58-1.537c.46 0 .834.373.834.833v1.667h1.666a.833.833 0 110 1.666h-2.5A.833.833 0 018.834 8V5.5c0-.46.373-.833.833-.833z",
  fill: "#1973E8"
}));
var _default = exports.default = History;